import cookie from 'react-cookie';

export const getForecast = (state) => {
  const data = state.forecast.forecast;
  if (data) {
    return data;
  }
  return null;
};

export const getIsForecastLoading = (state) => {
  const data = state.forecast.loading;
  if (data) {
    return data;
  }
  return false;
};

export const getHasFetchedForecast = (state) => {
  const data = state.forecast.hasFetched;
  if (data) {
    return data;
  }
  return null;
};

export const showPrintVersion = (state) => {
  const data = state.forecast.printVersion;
  return !!data;
};



// WEBPACK FOOTER //
// ./src/selectors/forecast.js